module.exports = __webpack_public_path__ + "static/media/gradient-bg.5c8be823.svg";